import axios from "axios";
import Vue from "vue";
import helper from "../../util/helper";

export default {
  state: () => ({
    closeAccounts: {},
    selectedAccount: {
      caseModelList: [],
    },
    isOpenAccount: false,
    selectedCloseAccount: {},
    selectedCloseUnit: null,
    autoCloseShown: true,
    informationForAutoClosePopUp: {},
  }),

  mutations: {
    setSelectedCloseAccount(state, closeAccount) {
      Vue.set(state, "selectedCloseAccount", closeAccount);
    },
    setCloseAccounts(state, closeAccounts) {
      Vue.set(state, "closeAccounts", closeAccounts);
    },
    setSelectedAccount(state, selectedAccount) {
      Vue.set(state, "selectedAccount", selectedAccount);
    },
    setIsOpenAccount(state, isOpenAccount) {
      Vue.set(state, "isOpenAccount", isOpenAccount);
    },
    setSelectedCloseUnit(state, selectedCloseUnit) {
      Vue.set(state, "selectedCloseUnit", selectedCloseUnit);
    },
    setAutoCloseShown(state, autoCloseShown) {
      Vue.set(state, "autoCloseShown", autoCloseShown);
    },
    setInformationForAutoClosePopUp(state, informationForAutoClosePopUp) {
      Vue.set(state, "informationForAutoClosePopUp", informationForAutoClosePopUp);
    },
    setDefaultCloseAccountModule(state, informationForAutoClosePopUp) {
      Vue.set(state, "closeAccounts", {});
      Vue.set(state, "selectedAccount", {
        caseModelList: [],
      });
      Vue.set(state, "isOpenAccount", false);
      Vue.set(state, "selectedCloseAccount", {});
      Vue.set(state, "selectedCloseUnit", null);
      Vue.set(state, "autoCloseShown", true);
      Vue.set(state, "informationForAutoClosePopUp", {});
    },
  },

  actions: {
    searchAccounts: (context, request) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/cases/view-account", request)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },

    closeAccount: (context, request) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/cases/close-accounting", request)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    checkOpenAccount: (context, request) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/cases/check-open-transactions", request)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    getTransactionsByTicketNumber: (context, request) => {
      return axios
        .get(context.getters.getMcServiceUrl + "/cases/get-ticket-sales-by-ticket-number/" + request)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    updateTransactionDetail: (context, request) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/cases/update-transaction-detail", request)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    userHasOpenTransaction: (context, request) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/transactions/user-has-open-transaction", request)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
  },
  getters: {
    getSelectedCloseAccount: (state) => {
      return state.selectedCloseAccount;
    },
    getCloseAccounts: (state) => {
      return state.closeAccounts;
    },
    getSelectedAccount: (state) => {
      return state.selectedAccount;
    },
    getIsOpenAccount: (state) => {
      return state.isOpenAccount;
    },
    getSelectedCloseUnit: (state) => {
      return state.selectedCloseUnit;
    },
    getAutoCloseShown: (state) => {
      return state.autoCloseShown;
    },
    getInformationForAutoClosePopUp: (state) => {
      return state.informationForAutoClosePopUp;
    },
  },
};
